// Messages for portal/developers/AddWebhookModal (auto-merged by lib/i18n.ts).
export const en = {
  'portal.add_webhook.title': 'Add webhook endpoint',
  'portal.add_webhook.edit_title': 'Edit webhook endpoint',
  'portal.add_webhook.cancel': 'Cancel',
  'portal.add_webhook.add': 'Add endpoint',
  'portal.add_webhook.save': 'Save changes',
  'portal.add_webhook.url': 'Endpoint URL',
  'portal.add_webhook.url_placeholder': 'https://your-system.example/g4-hooks',
  'portal.add_webhook.url_hint':
    "Where we'll POST each subscribed event. Must be a public https URL.",
  'portal.add_webhook.events': 'Events',
  'portal.add_webhook.events_hint': 'Subscribe to one or more events on your own data.',
  'portal.add_webhook.events_selected': '{count} selected',
  'portal.add_webhook.select_all': 'Select all',
  'portal.add_webhook.clear_all': 'Clear all',
  'portal.add_webhook.format_label': 'Payload format',
  'portal.add_webhook.format_sub': 'How the body is shaped for the receiver.',
  'portal.add_webhook.format.json': 'JSON (generic)',
  'portal.add_webhook.format.teams': 'Microsoft Teams',
  'portal.add_webhook.format.slack': 'Slack',
  'portal.add_webhook.format_hint.json': 'Signed event envelope for your own integration.',
  'portal.add_webhook.format_hint.teams': 'Adaptive Card for a Teams / Power Automate flow.',
  'portal.add_webhook.format_hint.slack': 'Message for a Slack incoming webhook.',
}

export const zhTW = {
  'portal.add_webhook.title': '新增 Webhook 端點',
  'portal.add_webhook.edit_title': '編輯 Webhook 端點',
  'portal.add_webhook.cancel': '取消',
  'portal.add_webhook.add': '新增端點',
  'portal.add_webhook.save': '儲存變更',
  'portal.add_webhook.url': '端點網址',
  'portal.add_webhook.url_placeholder': 'https://your-system.example/g4-hooks',
  'portal.add_webhook.url_hint': '我們會將每個已訂閱的事件 POST 至此處。必須為公開的 https URL。',
  'portal.add_webhook.events': '事件',
  'portal.add_webhook.events_hint': '訂閱一個或多個您自身資料的事件。',
  'portal.add_webhook.events_selected': '已選 {count} 個',
  'portal.add_webhook.select_all': '全選',
  'portal.add_webhook.clear_all': '全部清除',
  'portal.add_webhook.format_label': '內容格式',
  'portal.add_webhook.format_sub': '依接收方需求調整內容格式。',
  'portal.add_webhook.format.json': 'JSON（通用）',
  'portal.add_webhook.format.teams': 'Microsoft Teams',
  'portal.add_webhook.format.slack': 'Slack',
  'portal.add_webhook.format_hint.json': '供自有整合使用的已簽署事件封包。',
  'portal.add_webhook.format_hint.teams': '供 Teams／Power Automate 流程使用的 Adaptive Card。',
  'portal.add_webhook.format_hint.slack': '供 Slack incoming webhook 使用的訊息。',
}
